import { resolveSiteUrl } from '../../configs/siteUrlConfig'

export const useSiteUrl = () => {
    const config = useRuntimeConfig()

    return resolveSiteUrl(config?.public?.host || 'localhost:3000')
}
